// Wrapper for fallback implementation when no service is available

import { isDevelopment } from '../utils/environment.js';

export const createFallbackAnalyticsService = () => {
  return {
    trackPageView: (pageName = 'unknown') => {
      if (isDevelopment) {
        console.log('[Fallback Analytics] trackPageView:', pageName);
      }
    },
    trackPageExit: (pageName = 'unknown') => {
      if (isDevelopment) {
        console.log('[Fallback Analytics] trackPageExit:', pageName);
      }
    },
    trackSearch: (searchData = {}) => {
      if (isDevelopment) {
        console.log('[Fallback Analytics] trackSearch:', searchData);
      }
    },
    trackProfileView: (candidateId, source = 'unknown') => {
      if (isDevelopment) {
        console.log('[Fallback Analytics] trackProfileView:', candidateId, source);
      }
    },
    trackSaveCandidate: (candidateId, isSaving) => {
      if (isDevelopment) {
        console.log('[Fallback Analytics] trackSaveCandidate:', candidateId, isSaving);
      }
    },
    trackContactCandidate: (candidateId, userId) => {
      if (isDevelopment) {
        console.log('[Fallback Analytics] trackContactCandidate:', candidateId, userId);
      }
    },
    trackFilterUse: (filterType, filterValue) => {
      if (isDevelopment) {
        console.log('[Fallback Analytics] trackFilterUse:', filterType, filterValue);
      }
    },
    trackResultsView: (count, page) => {
      if (isDevelopment) {
        console.log('[Fallback Analytics] trackResultsView:', count, page);
      }
    },
    trackInfiniteScroll: (page, totalSeen) => {
      if (isDevelopment) {
        console.log('[Fallback Analytics] trackInfiniteScroll:', page, totalSeen);
      }
    },
    trackError: (errorType, errorDetails) => {
      console.log('[Fallback Analytics] trackError:', errorType, errorDetails);
    }
  };
};

// Exports a default fallback service
export default createFallbackAnalyticsService();